import { createContext } from 'react'
import {
  ArticleType,
  TeaserMainTextAlignment,
  ComputedTeaserRatio,
} from '@widgets/Teaser/toi/types'
import { ComputedTeaserFlex } from '@widgets/Teaser/types'
import { ProcessedPost } from '@hooks/useNewstickerScribblePolling'

export interface TOITeaserLayoutContextType {
  mainTextAlignment: TeaserMainTextAlignment
  teaserFlex: ComputedTeaserFlex
  teaserRatio: ComputedTeaserRatio
  accentColor: string
  isInMegaModule: boolean
  articleType: ArticleType
}

export interface TOITeaserNewstickerContextType {
  posts: ProcessedPost[]
}

export type TOITeaserSportsTilesContextType = number

const TOITeaserLayoutContext = createContext<TOITeaserLayoutContextType>({
  mainTextAlignment: { v: 'bottom', h: 'left' },
  teaserFlex: {
    desktop: '6',
    tablet: '6',
    mobile: '6',
  },
  teaserRatio: {
    desktop: '2_1',
    tablet: '1_1',
    mobile: '1_1',
  },
  accentColor: '',
  isInMegaModule: false,
  articleType: 'default',
})

const TOITeaserNewstickerContext =
  createContext<TOITeaserNewstickerContextType>({ posts: [] })

const TOITeaserSportsTilesContext =
  createContext<TOITeaserSportsTilesContextType>(0)

const exports = {
  TOITeaserLayoutContext,
  TOITeaserNewstickerContext,
  TOITeaserSportsTilesContext,
}

export default exports
